module.exports = __webpack_public_path__ + "img/vertical_panou.2d5fb4d6.png";